module.exports = __webpack_public_path__ + "static/media/arrow1.f750170a.svg";